import React, { useState } from "react";
import {
  List,
  useTable,
  EditButton,
  DeleteButton,
  TableColumnType,
  Button,
  Table,
  SaveButton,
  Form,
  Input,
} from "@pankod/refine-antd";
import { ISearch } from "type";
import { useExport } from "@pankod/refine-core";
interface Props {
  tag_condition_id: string;
  type: string;
  ref1: string;
  ref2: string;
  ref3: string;
  ref4: string;
  ref5: string;
  created_at: string;
  updated_at: string;
}

export const TagConditionList = () => {
  const [query, setQuery] = useState("");
  const { tableProps, searchFormProps } = useTable({
    queryOptions: { retry: false },
    onSearch: (values: ISearch) => {
      return [
        {
          field: "q",
          operator: "contains",
          value: values.q ? values.q : null,
        },
      ];
    },
  });
  const { triggerExport } = useExport({
    filters: [
      {
        field: "q",
        operator: "contains",
        value: query,
      },
    ],
  });
  const columns = React.useMemo<TableColumnType<any>[]>(
    () => [
      {
        dataIndex: "tag_condition_id",
        title: "Tag Condition Id",
        type: "number",
        width: 120,
        align: "center",
        headerAlign: "center",
        ellipsis: {
          showTitle: false,
        },
        fixed: "left",
      },
      {
        dataIndex: "type",
        title: "Type",
        type: "string",
        headerAlign: "left",
        align: "left",
        width: 150,
      },
      {
        dataIndex: "ref1",
        title: "ref 1",
        type: "string",
        headerAlign: "left",
        align: "left",
        width: 50,
        ellipsis: {
          showTitle: false,
        },
      },
      {
        dataIndex: "ref2",
        title: "ref 2",
        type: "string",
        headerAlign: "left",
        align: "left",
        width: 50,
        ellipsis: {
          showTitle: false,
        },
      },
      {
        dataIndex: "ref3",
        title: "ref 3",
        type: "string",
        headerAlign: "left",
        align: "left",
        width: 50,
        ellipsis: {
          showTitle: false,
        },
      },
      {
        dataIndex: "ref4",
        title: "ref 4",
        type: "string",
        headerAlign: "left",
        align: "left",
        width: 50,
        ellipsis: {
          showTitle: false,
        },
      },
      {
        dataIndex: "ref5",
        title: "ref 5",
        type: "string",
        headerAlign: "left",
        align: "left",
        width: 50,
        ellipsis: {
          showTitle: false,
        },
      },
      {
        dataIndex: "created_at",
        title: "Created At",
        width: 200,
      },
      {
        dataIndex: "updated_at",
        title: "Updated At",
        width: 200,
      },
      {
        dataIndex: "actions",
        title: "Actions",
        render: (_, record) => {
          return (
            <>
              <EditButton hideText recordItemId={record.tag_condition_id} />
              <DeleteButton hideText recordItemId={record.tag_condition_id} />
            </>
          );
        },
        align: "center",
        headerAlign: "center",
        width: 80,
        fixed: "right",
      },
    ],
    []
  );

  return (
    <List
      headerButtons={({ defaultButtons }) => (
        <>
          <Form {...searchFormProps} layout="inline">
            <Form.Item name="q">
              <Input
                placeholder="Search by ..."
                onChange={(e) => {
                  setQuery(e.target.value);
                }}
              />
            </Form.Item>
            <SaveButton type="default" onClick={searchFormProps.form?.submit}>
              SEARCH
            </SaveButton>
          </Form>
          {defaultButtons}
          <Button type="primary" onClick={triggerExport}>
            EXPORT
          </Button>
        </>
      )}
    >
      <Table
        {...tableProps}
        bordered={true}
        rowKey="tag_condition_id"
        columns={columns}
        scroll={{ x: 1500 }}
        size="middle"
        pagination={{
          ...tableProps.pagination,
          position: ["bottomRight"],
          size: "default",
        }}
      ></Table>
    </List>
  );
};
